// import Qs from 'qs'
var modulesFiles = require.context('./modules', true, /\.js$/)

// it will auto require all modules file
var modules = modulesFiles.keys().reduce((modules, modulePath) => {
  var value = modulesFiles(modulePath)
  Object.assign(modules, value)
  return modules
}, {})

export default modules
